<div
  class="description-panel"
  *ngIf="formattedDescription && formattedDescription.shortContent"
  [ngClass]="{
    'popover-description': isInPopover
  }">
  <rad-icon
    *ngIf="isWarning"
    class="rad-icon rad-icon-color-error"
    name="exclamationTriangle"
    size="compact"
  ></rad-icon>
  <span
    class='form-field-description-content allow-link-break'
    [ngClass]="{'color-error': isWarning}"
    [innerHtml]="displayContent">
  </span>
  <lib-popover
      *ngIf="!isInPopover && formattedDescription.longContent"
      class="ml-2"
      popoverType="ellipsis"
      popoverSize="medium"
      popoverPlacement="right">
      <span class="allow-link-break" [innerHtml]="formattedDescription.longContent"></span>
  </lib-popover>
</div>
